<template>
  <div v-if="detail" ref="captureTarget" class="salary-detail-page">
    <div class="detail-scroll">
      <section class="detail-card">
        <header class="detail-header">
          <div class="detail-user">
            <span class="detail-name">{{ detail.memberName }}</span>
            <span class="detail-id">({{ detail.entQrcodeId }})</span>
          </div>
          <div class="detail-title">{{ detail.title }}</div>
        </header>

        <!--<div class="detail-section-title">薪资明细</div>-->

        <section v-for="section in detail.sections" :key="section.ruleKey" class="detail-section">
          <h3 class="block-title">{{ section.title }}</h3>

          <div v-for="(item, itemIndex) in section.items" :key="`${section.ruleKey}-${itemIndex}`" class="detail-item">
            <!-- 方案名称 -->
            <div v-if="item.planName" class="detail-item-row">
              <div class="detail-item-name" style="font-weight: 700; color: #000;">{{ item.planName }}</div>
            </div>
            <div class="detail-item-row">
              <div class="detail-item-name">{{ formatDetailItemLine(item) }}</div>
              <div class="detail-item-amount">{{ item.amount }}</div>
            </div>
          </div>
        </section>

        <section v-if="detail.adjustments.length" class="detail-section detail-section-adjust">
          <h3 class="block-title">薪资调整</h3>
          <div
            v-for="(adjustment, index) in detail.adjustments"
            :key="`adjust-${index}`"
            class="detail-item"
          >
            <div class="detail-item-row detail-item-row-adjust">
              <div class="detail-adjust-label">
                {{ adjustment.label }}
                
              </div>
              <button type="button" class="reason-link" @click="toggleReason(index)">
                  [{{ isReasonVisible(index) ? '收起原因' : '查看原因' }}]
                </button>
              <div class="detail-item-amount">{{ adjustment.amount }}</div>
            </div>
            <div v-if="isReasonVisible(index)" class="reason-box">{{ adjustment.reason }}</div>
          </div>
        </section>
      </section>
    </div>

    <footer class="total-footer">
      <div class="total-info">
        <div class="total-label">{{ detail.totalLabel }}</div>
        <div class="total-amount">{{ detail.totalAmount }}</div>
      </div>
      <button type="button" class="save-button" @click="saveToAlbum">
        <span class="save-icon">↓</span>
        <span>保存相册</span>
      </button>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import html2canvas from 'html2canvas';
import { Toast, Dialog } from 'vant';
import listener from "../../utils/listener";
import { handleBuryPoint, isAndroid } from "../../utils/tool.js";
import { reqSalaryTemplateDefaultConfig, reqSalaryMemberDetail } from '@/apis/serviceApi.js';

Vue.use(Toast);
Vue.use(Dialog);

const SALARY_DETAIL_PAGE_EVENT = 'h5-sudaseeker_salaryDetailPage';

export default {
  name: 'SalaryDetailPage',
  data() {
    return {
      detail: null,
      reasonVisibleMap: {},
      generatedImageBase64: '',
    };
  },
  created() {
    this.trackBuryPoint('show', {
      groupId: this.$route.query.groupId || '',
      cityCode: this.$route.query.cityCode || '',
      memberId: this.$route.query.memberId || this.$route.query.id || '',
      salaryRecordId: this.$route.query.salaryRecordId || '',
      calcDate: this.$route.query.calcDate || '',
    });
    this.loadDetail();
  },
  watch: {
    $route() {
      this.loadDetail();
    },
  },
  mounted() {
    // 授权返回
    listener.addReceiver("AUTHORIZED_SUCCESS", (e) => {
      console.log("授权结果", e);
      if (!e) {
        // vant 的 Dialog 提示去授权
        this.$dialog.confirm({
          title: '需要授权存储权限',
          message: '请前往设置授权存储权限，以便保存图片到相册',
          confirmButtonText: '去授权',
           cancelButtonText: '算了',
        })
          .then(() => {
            // 去授权
            window.AmapApp.bridge.send({
              action: 'openPermissionsSetting'
            })
          })
          .catch(() => {});
        this.authorizedResult = 1
        return;
      }
      this.authorizedResult = 2;
      if (window.__salaryDetailImageBase64) {
        this.handleImageBtn(
        window.__salaryDetailImageBase64
      );
      } else {
        this.saveToAlbum();
      }
      
    });
  },
  methods: {
    trackBuryPoint(event, params) {
      handleBuryPoint(SALARY_DETAIL_PAGE_EVENT, event, params || {});
    },
    formatCurrency(value, forceNegative) {
      const amount = Math.abs(Number(value || 0));
      const prefix = forceNegative ? '-¥ ' : '¥ ';
      return `${prefix}${amount.toFixed(2)}`;
    },
    getRequestParams() {
      return {
        groupId: Number(this.$route.query.groupId || 0),
        cityCode: this.$route.query.cityCode || '',
        memberId: this.$route.query.memberId || this.$route.query.id || '',
        salaryRecordId: this.$route.query.salaryRecordId || '',
        calcDate: this.$route.query.calcDate || '',
      };
    },
    mapSalaryDetailItem(sectionRuleKey, item, ruleTypeMap, indicatorMap, ruleMap) {
      const indicatorMeta = item.indicatorKey ? (indicatorMap[item.indicatorKey] || {}) : {};
      const ruleTypeMeta = ruleTypeMap[item.ruleType] || {};
      const extraParts = [];
      if (item.indicatorVal !== null && item.indicatorVal !== undefined && item.indicatorVal !== '') {
        extraParts.push(String(item.indicatorVal));
      }

      return {
        // 方案名称
        planName: item.ruleKey ? (ruleMap[item.ruleKey]['ruleName'] || '--') : '--',
        label: item.indicatorKey ? (indicatorMeta.indicatorName || '--') : '无指标',
        extra: extraParts.join(''),
        unit: item.indicatorKey ? (indicatorMeta.unit || '') : '',
        amount: this.formatAmount(item.salary, sectionRuleKey === 'deduct'),
      };
    },
    formatAmount(value, forceNegative) {
      const amount = Math.abs(Number(value || 0));
      const prefix = forceNegative ? '-' : '';
      return `${prefix}${amount.toFixed(2)}`;
    },
    formatDetailItemLine(item) {
      const suffix = item.extra ? `：${item.extra}${item.unit || ''}` : '';
      return `${item.label || '--'}${suffix}`;
    },
    mapResponse(data, defaultConfig) {
      const {
        ruleMap,
        ruleTypeMap,
        indicatorMap,
      } = defaultConfig || {};
      const confirmStatus = Number(data.confirmStatus || 10);
      const sections = (data.salaryList || [])
        .slice()
        .sort((left, right) => Number(left.sort || 0) - Number(right.sort || 0))
        .map((section) => ({
          ruleKey: section.ruleKey || '',
          title: ruleMap[section.ruleKey]['ruleName'] || '--',
          items: (section.ruleDetailList || []).map((item) => this.mapSalaryDetailItem(section.ruleKey, item, ruleTypeMap, indicatorMap, ruleMap)),
        }));
      const adjustments = (data.adjustSalaryList || []).map((item) => ({
        //label: `薪资调整（调整前 ${this.formatCurrency(item.beforeSalary)} / 调整后 ${this.formatCurrency(item.afterSalary)}）`,
        label: `${this.formatCurrency(item.beforeSalary, Number(item.beforeSalary || 0) < 0)} ➝ ${this.formatCurrency(item.afterSalary, Number(item.afterSalary || 0) < 0)}`,
        amount: this.formatCurrency(item.adjustSalary, Number(item.adjustSalary || 0) < 0),
        reason: item.remark || '暂无原因',
      }));
      let totalAmount = null;
      totalAmount = confirmStatus === 20 ? data.settlementSalary : data.suggestSalary;
      return {
        memberId: data.memberId || '',
        promotionInviteCode: data.promotionInviteCode || '',
        entQrcodeId: data.entQrcodeId || '',
        memberName: data.memberName || '--',
        title: confirmStatus === 20 ? '实际结算薪资' : '建议薪资',
        totalLabel: confirmStatus === 20 ? '总计结算薪资' : '总计建议薪资',
        totalAmount: this.formatCurrency(totalAmount, Number(totalAmount || 0) < 0),
        sections,
        adjustments,
      };
    },
    loadDetail() {
      const params = this.getRequestParams();
      this.trackBuryPoint('loadDetail_params', params);
      if (!params.groupId || !params.memberId || !params.salaryRecordId || !params.calcDate || !params.cityCode) {
        this.trackBuryPoint('loadDetail_invalidParams', params);
        this.showToast('缺少薪资详情必要参数');
        this.$router.replace({ name: 'Salary', query: this.$route.query });
        return;
      }
      
      reqSalaryTemplateDefaultConfig({
        groupId: params.groupId
      })
        .then((resConf) => {
          if (resConf && resConf.code === 1) {
            this.trackBuryPoint('reqSalaryTemplateDefaultConfig_success', {
              groupId: params.groupId,
            });
            //console.log('默认配置：', resConf.data);
            this.reqSalaryMemberDetail(params, resConf.data);
          } else {
            this.trackBuryPoint('reqSalaryTemplateDefaultConfig_err', {
              groupId: params.groupId,
              code: resConf && resConf.code,
              msg: resConf && resConf.msg,
            });
            this.showToast('获取默认配置失败');
            this.$router.replace({ name: 'Salary', query: this.$route.query });
          }
        })
        .catch((error) => {
          this.trackBuryPoint('reqSalaryTemplateDefaultConfig_catch', {
            groupId: params.groupId,
            errorMessage: error && error.message ? error.message : '',
          });
          this.showToast('获取默认配置异常');
          this.$router.replace({ name: 'Salary', query: this.$route.query });
        });

      
    },
    reqSalaryMemberDetail(params, defaultConfig) {
      this.trackBuryPoint('reqSalaryMemberDetail_params', params);
      reqSalaryMemberDetail(params)
        .then((res) => {
          if (res && res.code === 1) {
            //console.log('原始接口响应：', res.data);
            this.detail = this.mapResponse(res.data, defaultConfig);
            this.trackBuryPoint('reqSalaryMemberDetail_success', {
              memberId: params.memberId,
              salaryRecordId: params.salaryRecordId,
              sectionCount: (this.detail && this.detail.sections && this.detail.sections.length) || 0,
              adjustmentCount: (this.detail && this.detail.adjustments && this.detail.adjustments.length) || 0,
            });
          } else {
            this.trackBuryPoint('reqSalaryMemberDetail_err', {
              memberId: params.memberId,
              salaryRecordId: params.salaryRecordId,
              code: res && res.code,
              msg: res && res.msg,
            });
            this.showToast('获取薪资详情失败');
            //this.$router.replace({ name: 'Salary', query: this.$route.query });
          }
        })
        .catch((e) => {
          this.trackBuryPoint('reqSalaryMemberDetail_catch', {
            memberId: params.memberId,
            salaryRecordId: params.salaryRecordId,
            errorMessage: e && e.message ? e.message : '',
          });
            console.error('获取薪资详情异常：', e);
          this.showToast('获取薪资详情异常');
          //this.$router.replace({ name: 'Salary', query: this.$route.query });
        });
    },
    isReasonVisible(index) {
      return Boolean(this.reasonVisibleMap[index]);
    },
    toggleReason(index) {
      this.trackBuryPoint('toggleReason_click', {
        index: index,
        nextVisible: !this.reasonVisibleMap[index],
      });
      this.reasonVisibleMap = Object.assign({}, this.reasonVisibleMap, {
        [index]: !this.reasonVisibleMap[index],
      });
    },
    async saveToAlbum() {
      this.trackBuryPoint('saveToAlbum_click', {
        memberId: this.detail && this.detail.memberId,
        hasCaptureTarget: !!this.$refs.captureTarget,
      });
      if (!this.$refs.captureTarget) {
        this.showToast('当前页面未准备好');
        return;
      }
      try {
        const canvas = await html2canvas(this.$refs.captureTarget, {
          backgroundColor: '#f3f4f8',
          scale: 2,
          useCORS: true,
        });
        const base64 = canvas.toDataURL('image/png');
        this.generatedImageBase64 = base64;
        window.__salaryDetailImageBase64 = base64;
        this.trackBuryPoint('saveToAlbum_generate_success', {
          memberId: this.detail && this.detail.memberId,
          imageLength: base64.length,
        });
        //this.showToast('页面图片已生成，请继续处理保存逻辑');
        this.handleImageBtn(base64);
      } catch (error) {
        this.trackBuryPoint('saveToAlbum_generate_catch', {
          memberId: this.detail && this.detail.memberId,
          errorMessage: error && error.message ? error.message : '',
        });
        this.showToast('生成图片失败');
      }
    },
    handleImageBtn(imageUrl) {
      if (isAndroid()) {
        console.log('安卓设备，开始授权流程');
        console.log('当前授权结果：', this.authorizedResult);
        if (this.authorizedResult !== 2) {
          console.log('用户拒绝授权，提示需要授权');
          const objs = {
            action: "applyPermissionAction",
            permission: "photo",
          };
          window.AmapApp.bridge.send(objs, (res) => {
            console.log("保存本地成功", res);
            const { photo } = res;
            // 拒绝， 发送广播到ajx，授权
            if (photo == "rejectPermission") {
              listener.broadcast("H5_APPLY_PHOTO_PERMISSION");
            } else {
              console.log("用户已授权，继续保存图片1");
              this.authorizedResult = 2
              this.handleSaveImage(imageUrl)
            }
          });
        } else {
          console.log('已授权，继续保存图片2');
          this.handleSaveImage(imageUrl)
        }
    } else {
      this.handleSaveImage(imageUrl)
    }
    },
    handleSaveImage(imageUrl) {
      this.trackBuryPoint('savePhotoToGalleryAction_params', {
        memberId: this.detail && this.detail.memberId,
        imageLength: imageUrl ? imageUrl.length : 0,
      });
      console.log('调用原生保存图片接口，参数：');
      const obj = {
        action: "savePhotoToGalleryAction",
        imageUrl,
      };
      window.AmapApp.bridge.send(obj, (res) => {
        console.log('保存成功', res)
        if (res.result) {
          this.trackBuryPoint('savePhotoToGalleryAction_success', {
            memberId: this.detail && this.detail.memberId,
          });
          this.showToast('保存成功')
          return;
        }
        this.trackBuryPoint('savePhotoToGalleryAction_err', {
          memberId: this.detail && this.detail.memberId,
          result: res && res.result,
        });
      })
    },
    showToast(message) {
      Toast({
        message,
        duration: 1600,
      });
    },
  },
};
</script>

<style scoped>
.salary-detail-page {
  min-height: 100vh;
  padding: 16px 14px 136px;
  background: #f3f4f8;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue',
    'Microsoft YaHei', sans-serif;
  color: #1f2738;
  box-sizing: border-box;
}

.detail-card {
  background: #ffffff;
  border-radius: 0;
  min-height: calc(100vh - 172px);
  padding: 28px 22px 28px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.detail-scroll {
  max-width: 880px;
  margin: 0 auto;
}

.detail-user {
  display: flex;
  align-items: baseline;
  gap: 12px;
  min-width: 0;
}

.detail-name,
.detail-title {
  font-size: 38px;
  line-height: 1.2;
  font-weight: 700;
  color: #1a2234;
}

.detail-id {
  font-size: 26px;
  line-height: 1.3;
  color: #667085;
}

.detail-title {
  flex-shrink: 0;
  text-align: right;
}

.detail-section-title {
  margin-top: 22px;
  font-size: 26px;
  line-height: 28px;
  font-weight: 700;
  color: #1d2435;
}

.detail-section {
  margin-top: 26px;
}

.block-title {
  margin: 0 0 18px;
  font-size: 38px;
  line-height: 1.2;
  font-weight: 700;
  color: #1d2435;
}

.detail-item + .detail-item {
  margin-top: 18px;
}

.detail-item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.detail-item-name,
.detail-item-amount,
.detail-adjust-label {
  font-size: 26px;
  line-height: 1.5;
  color: #1f2738;
}

.detail-item-name,
.detail-adjust-label {
  font-weight: 500;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detail-item-amount {
  flex-shrink: 0;
  font-weight: 500;
  text-align: right;
}

.detail-section-adjust {
  margin-top: 24px;
}

.detail-item-row-adjust {
  align-items: center;
}

.reason-link {
  border: none;
  background: transparent;
  padding: 0;
  margin-left: 4px;
  font-size: 26px;
  line-height: 1.4;
  color: #3877ed;
}

.reason-box {
  margin-top: 14px;
  min-height: 118px;
  padding: 18px 20px;
  border-radius: 8px;
  background: #f2f3f6;
  font-size: 26px;
  line-height: 1.5;
  color: #202939;
  box-sizing: border-box;
}

.total-footer {
  position: fixed;
  left: 14px;
  right: 14px;
  bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 20px 18px 18px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 4px 18px rgba(30, 40, 70, 0.12);
}

.total-info {
  min-width: 0;
}

.total-label {
  font-size: 26px;
  line-height: 25px;
  font-weight: 700;
  color: #1c2334;
}

.total-amount {
  margin-top: 10px;
  font-size: 38px;
  line-height: 39px;
  font-weight: 700;
  color: #4b83f5;
}

.save-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 126px;
  height: 56px;
  padding: 0 18px;
  border: none;
  border-radius: 6px;
  background: #4780f2;
  color: #ffffff;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 500;
}

.save-icon {
  font-size: 26px;
  line-height: 1.2;
}
</style>